module.exports = __webpack_public_path__ + "img/task-1.44a94ac1.png";